import React, { useContext, useState, useEffect } from 'react';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import { mixpanelEventTrack, registerMixpanelEvent } from '../../services/mixpanel';
import '../../assets/styles/menu.sass';
import { ReactComponent as Profile } from '../../assets/img/user-regular-icon-grey.svg';
import { ReactComponent as Email } from '../../assets/img/email-icon.svg';
import { ReactComponent as BackBtn } from '../../assets/img/arrow.svg';
import smsIcon from '../../assets/img/sms-icon.png';
import Switch from 'react-switch';

const ProfileMenu = ({ setOpenProfile }) => {
  const context = useContext(BookerContext);
  const {
    state: { userProfile, isWebBooker },
    updateUserProfile,
  } = context;
  const { togglePopup } = useContext(BookerShortContext);

  const [checked, setChecked] = useState(userProfile.sms_enabled);
  const disableNotifications = () => {
    //Todo: send disable true through api
    FetchService.getWebApiResource(urlService.updateProfileSms(false))
      .then(response => {
        mixpanelEventTrack(isWebBooker ? 'smsDisabledOnProfileMenuWebBook' : 'smsDisabledOnProfileMenu');
        updateUserProfile({ ...userProfile, sms_enabled: false });
      })
      .catch(error => {
        console.log('sms disabled error');
      });

    togglePopup(false, 'manageSmsNotificationMenu');
  };

  const cancelDisable = () => {
    setChecked(true);
    togglePopup(false, 'manageSmsNotificationMenu');
  };

  const handleChange = nextChecked => {
    setChecked(nextChecked);
    if (!nextChecked) {
      togglePopup(true, 'manageSmsNotificationMenu', [
        { textBtn: 'Disable Notifications', clickHandler: disableNotifications },
        { textBtn: 'Cancel', clickHandler: cancelDisable },
      ]);
    } else {
      FetchService.getWebApiResource(urlService.updateProfileSms(true))
        .then(response => {
          mixpanelEventTrack(isWebBooker ? 'smsEnabledOnProfileMenuWebBook' : 'smsEnabledOnProfileMenu');
          updateUserProfile({ ...userProfile, sms_enabled: true });
        })
        .catch(error => {
          console.log('sms enabled error');
        });
    }
  };

  return (
    <div className="animated fadeIn clearfix sub-menu-info-dropdown">
      <div className="profile-main-menu">
        <div className="menu-item-title-container">
          <div className="back-btn">
            <BackBtn onClick={() => setOpenProfile(false)} />
          </div>
          <div className="menu-item-title">Profile</div>
        </div>
        <ul className="dropdown-list clearfix">
          <li className="dropdown-item">
            <Profile />
            <div className="profile-item">
              <div className="profile-item-title">Name</div>
              <div className="profile-item-value">{userProfile.first_name}</div>
            </div>
          </li>
          <li className="dropdown-item">
            <Profile />
            <div className="profile-item">
              <div className="profile-item-title">Last Name</div>
              <div className="profile-item-value">{userProfile.last_name}</div>
            </div>
          </li>
          <li className="dropdown-item profile-email-item">
            <Email />
            <div className="profile-item">
              <div className="profile-item-title">Email</div>
              <div className="profile-item-value">{userProfile.email || userProfile.login_email}</div>
            </div>
          </li>
        </ul>
      </div>
      <div className="profile-sub-menu">
        <div className="menu-item-title-container">
          <div className="menu-item-title">Notifications</div>
        </div>
        <ul className="dropdown-list clearfix">
          <li className="dropdown-item">
            <img src={smsIcon} className="sms-icon" alt="Sms Notification" />
            <div className="profile-item">
              <div className="profile-item-value">SMS</div>
            </div>
            <div>
              <Switch
                onChange={handleChange}
                checked={checked}
                className="react-switch"
                onColor="#a4ddcc"
                onHandleColor="#16ad74"
                handleDiameter={20}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0)"
                height={10}
                width={30}
              />
            </div>
          </li>
        </ul>
        <div className="sms-note">Sign up for text notifications to get important ride updates</div>
      </div>
    </div>
  );
};

export default ProfileMenu;
